<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>Liberação de Créditos</v-card-title>
            <v-card-subtitle>
                Libere os créditos para serem repassados e então créditados na conta dos artistas.
                <br />Os valores ficam com status de "a repassar" até que sejam são creditado na conta dos artistas. Esse repasse ocorre todos os dias às 01:00 da manhã.
            </v-card-subtitle>
            <v-card-actions>
                <v-btn
                    text
                    :to="{name:'liberacaocredito_status',params:{status:'cotacao_atualizada'}}"
                >não liberado</v-btn>
                <v-btn
                    text
                    :to="{name:'liberacaocredito_status',params:{status:'credito_a_repassar'}}"
                >a repassar</v-btn>
                <v-btn
                    text
                    :to="{name:'liberacaocredito_status',params:{status:'credito_liberado'}}"
                >creditado</v-btn>
            </v-card-actions>
            <v-data-table
                :footer-props="{itemsPerPageOptions:[50,100,200]}"
                :headers="headers"
                :items="items"
            >
                <template v-slot:item.total_moeda="{item}">
                    <money disabled v-model="item.total_moeda" v-bind="$globalformmasks.money_9p"></money>
                </template>
                <template v-slot:item.t_currency_rate="{item}">
                    <money prefix="R$ " disabled v-model="item.t_currency_rate" v-bind="$globalformmasks.money_9p"></money>
                </template>
                <template v-slot:item.total_real="{item}">
                    <money prefix="R$ " disabled v-model="item.total_real" v-bind="$globalformmasks.money_9p"></money>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn
                        v-if="$route.params.status=='cotacao_atualizada'"
                        icon
                        text
                        @click="dialog_editar_liberacao(item)"
                    >
                        &nbsp;
                        <v-icon small class="mr-2" outline>north_east</v-icon>
                    </v-btn>
                    <!--v-btn
                        v-if="$route.params.status=='credito_a_repassar'"
                        icon
                        text
                        :to="{name:'cotacaomensal_edit',params:{partner:item.s_partner,partner_service:item.s_partner_company}}"
                    >
                        &nbsp;
                        <v-icon small class="mr-2" outline>south_west</v-icon>
                    </v-btn-->
                </template>
            </v-data-table>
        </v-card>
        <!---->
        <v-dialog ref="dialog_liberar" v-model="dialog_liberar" persistent width="390px">
            <v-card>
                <v-card-title class="headline">Liberar Crédito</v-card-title>

                <v-card-text>
                    Essa ação liberará o item abaixo para crédito na conta dos artistas.
                    <br />
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td>Parceiro</td>
                                    <td>
                                        <b>{{item_a_liberar.s_partner}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Serviço</td>
                                    <td>
                                        <b>{{item_a_liberar.s_partner_company}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Período</td>
                                    <td>
                                        <b>{{item_a_liberar.i_date}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Moeda</td>
                                    <td>
                                        <b>{{item_a_liberar.s_currency}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Artistas Moeda</td>
                                    <td>
                                        <b><money prefix="R$ " disabled v-model="item_a_liberar.total_moeda" v-bind="$globalformmasks.money_9p"></money></b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Artistas BRL</td>
                                    <td>
                                        <b><money prefix="R$ " disabled v-model="item_a_liberar.total_real" v-bind="$globalformmasks.money_9p"></money></b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-checkbox
                                            v-model="estou_ciente_check"
                                            :value="true"
                                            label="Estou ciente que ao clicar em 'liberar este crédito' os valores serão distribuídos entre os artistas do NMG e que essa ação ficará vinculada ao histórico da minha conta."
                                        ></v-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="red darken-1" text @click="dialog_liberar = false; estou_ciente_check= false;">Cancelar</v-btn>

                    <v-btn
                        :disabled="!estou_ciente_check"
                        color="green darken-1"
                        text
                        @click="liberar_credito()"
                    >Liberar este crédito</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!---->
        <!-- MODAL -->
        <modalmessage ref="modal"/>
        <!--/MODAL -->
    </v-sheet>
</template>

<script>
import LiberacaoService from "../../../../app/rest/financeiro_liberacao";
import modalmessage from "../../../../components/shared/modalmessage";
var liberacaoService = null;

export default {
    components: {
        modalmessage
    },
    data: () => ({
        item_a_liberar: {},
        estou_ciente_check:false,
        search: "",
        dialog_liberar: false,
        status_padrao: "cotacao_atualizaca",
        items: [],
        headers: [
            {
                text: "Plataforma",
                align: "left",
                sortable: false,
                value: "s_partner"
            },
            { text: "Serviço", value: "s_partner_company" },
            { text:'Artistas beneficiados', value:'total_artistas'},
            { text: "Período", value: "i_date" },
            { text: "Moeda", value: "s_currency" },
            { text: "Artistas Moeda", value: "total_moeda" },
            { text: "Cotação efetiva", value: "t_currency_rate" },
            { text: "Artistas BRL", value: "total_real" },
            { text: "Ações", value: "actions" }
        ]
    }),
    beforeMount: function() {
        liberacaoService = LiberacaoService.build();
        this.load_liberacoes();
    },
    watch: {
        $route() {
            this.load_liberacoes();
        }
    },
    methods: {
        liberar_credito(){
            this.$store.dispatch("loading",true);
            this.dialog_liberar = false;
            liberacaoService.liberar_periodo(this.item_a_liberar).then(e=>{
                if(e.status == 'ok'){
                    this.$refs.modal.show({
                        title: "Período liberado!",
                        message: "Essa liberação estará em breve na conta do artista.",
                        btn_1_text: "Entendi",
                        btn_1_action:()=>{
                            this.load_liberacoes();
                        }                          
                    });       
                                 

                }else{
                    this.$refs.modal.show({
                        title: "Tivemos um problema!",
                        message: e.message,
                        btn_1_text: "Entendi"                     
                    });       
                }

            }).catch(e=>{                
                this.$refs.modal.show({
                    title: "Tivemos um problema nessa liberação!",
                    message: `Por favor atualize a página e tente liberar novamente! ${e}`,
                    btn_1_text: "shiiiiii"                        
                });                
            }).finally(()=>{
                this.estou_ciente_check = false;
                this.$store.dispatch("loading", false);
            });

        },
        dialog_editar_liberacao(item) {
            this.item_a_liberar = item;
            this.dialog_liberar = true;
        },
        load_liberacoes() {
            var status_padrao = this.status_padrao;
            if (this.$route.params.status) {
                status_padrao = this.$route.params.status;
            }

            this.$store.dispatch("loading");
            
            liberacaoService
                .get_all(status_padrao)
                .then(e => {
                    if (e.status == "ok") {
                        this.items = e.items.liberacoes.map(function(ee){
                            ee.t_currency_rate = Number(ee.t_currency_rate)
                            ee.total_moeda = Number(ee.total_moeda)
                            ee.total_real = Number(ee.total_real)
                            return ee;
                        });
                    }
                })
                .catch( ()=> {

                })
                .finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
    }
};
</script>